import React from 'react';
import './LoadingSpinner.css';

type LoadingSpinnerProps = {
  label?: string;
};

export default function LoadingSpinner({ label = 'Loading' }: LoadingSpinnerProps) {
  return (
    <div className="spinner" role="status" aria-label={label} aria-live="polite">
      <span className="visually-hidden">{label}</span>
    </div>
  );
}
